<template>
    <div class="table-responsive">
        <el-table
            size="small"
            border
            class="el-table-css clinic-groups-table"
            :data="useTable"
            style="width: 100%;"
            lazy
            @expand-change="loadChild"
        >
            <el-table-column type="expand">
                <template #default="props">
                    <div class="clinic-expand">
                        <div class="clinic-filter-bar">
                            <el-select
                                v-model="checkOpt[props.row.indexId]"
                                class="clinic-filter-bar__services"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                filterable
                                default-first-option
                                :reserve-keyword="false"
                                :placeholder="$t('commonSelectServices')"
                                @change="filterTable(props.row.indexId)"
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                            <el-input
                                v-model="search[props.row.indexId].value"
                                class="clinic-filter-bar__search"
                                clearable
                                :placeholder="$t('commonSearch')"
                                :prefix-icon="Search"
                            />
                        </div>
                        <el-table
                            v-loading="loading"
                            border
                            class="clinic-child-table el-table-css"
                            :data="childTable[props.row.indexId]"
                            max-height="510"
                            :row-style="{ cursor: 'default' }"
                        >
                            <el-table-column :label="$t('clinicsFacilityName')" prop="displayName" />
                            <el-table-column :label="$t('commonAddress')" prop="address" />
                            <el-table-column :label="$t('commonPhoneShort')" prop="phone" />
                            <el-table-column label="TTY" width="50">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.emerg == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Amb" width="50">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.outp == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Stas" width="50">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.inp == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('clinicsBirth')" width="60">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.birth == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Lab" width="50">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.lab == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Stom" width="55">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.stom == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div><!-- <el-checkbox disabled="true" v-model="scope.row.stom" size="large" /> -->
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('clinicsMedicine')" width="70">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.pharm == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Optika" width="60">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.opt == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('clinicsDelivery')" width="65">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.dlvr == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Region" width="65">
                                <template #default="scope">
                                    <div style="text-align: center;">
                                        <i v-if="scope.row.regn == true" style="font-size: 18px;"
                                            class="bi bi-check-lg text-excel"></i>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <br>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="groupName" label="Grup" />
        </el-table>
    </div>
</template>
<script>
import { getPolicyId } from "@/project/Source/routes";
import { Search } from "@element-plus/icons-vue";
import Source from "@/project/Source/claim.js";

export default {
    props: {
        dataTable: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            Search,
            checkOpt: [],
            loading: false,
            childTable: [],
            childTableFilter: [],
            options: [
                {
                    value: 'emerg',
                    label: 'TTY',
                },
                {
                    value: 'outp',
                    label: 'Amb',
                },
                {
                    value: 'inp',
                    label: 'Stas',
                },
                {
                    value: 'birth',
                    label: 'Doğuş',
                },
                {
                    value: 'lab',
                    label: 'Lab',
                },
                {
                    value: 'stom',
                    label: 'Stom',
                },
                {
                    value: 'pharm',
                    label: 'Dərman',
                },
                {
                    value: 'opt',
                    label: 'Optika',
                },
                {
                    value: 'dlvr',
                    label: 'Çatdırılma',
                },
                {
                    value: 'regn',
                    label: 'Region',
                },
            ],
            search: null,
            oldSearch: null,
            useTable: null
        }
    },
    watch: {
        search: {
            handler(newVal) {
                if (!newVal || !this.oldSearch) return;
                newVal.forEach((item, index) => {
                    if (item.value !== this.oldSearch[index].value) {
                        this.filterTable(index)
                        this.oldSearch[index].value = item.value;
                    }
                });
            },
            deep: true
        }
    },
    mounted() {
        const data = {
            "id": getPolicyId(this.$route),
            "requestCorrelationId": "string"
        }
        Source.Groups(data).then((response) => {
            this.useTable = response.data.data
            this.useTable.forEach((item, index) => {
                item.isExpand = false;
                item.indexId = index;
            });
            this.search = []
            this.oldSearch = []
            for (var i = 0; i < this.useTable.length; i++) {
                this.search.push({ value: null })
                this.oldSearch.push({ value: null })
            }
        })
    },
    methods: {
        loadChild(expand) {
            const itemToUpdate = this.useTable.find(item => item.groupId === expand.groupId);
            if (this.childTable[itemToUpdate.indexId] == null) {
                this.loading = true
                const data = {
                    "id": itemToUpdate.groupId,
                    "requestCorrelationId": "string"
                }
                Source.PolicyClinics(data).then((responseFamily) => {
                    this.childTable[itemToUpdate.indexId] = responseFamily.data.data
                    this.childTableFilter[itemToUpdate.indexId] = responseFamily.data.data
                    this.loading = false
                })
            } else {
                this.childTable[itemToUpdate.indexId] = null
            }
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        filterTable(id) {
            if (this.search[id].value == null) { this.search[id].value = '' }
            const searchLower = this.search[id].value.toLowerCase();
            const selected = this.checkOpt[id] || [];
            if (this.childTableFilter[id] != null) {
                this.childTable[id] = this.childTableFilter[id].filter((item) =>
                    (selected.some(opt => opt === 'emerg') ? item.emerg === true : true) &&
                    (selected.some(opt => opt === 'outp') ? item.outp === true : true) &&
                    (selected.some(opt => opt === 'inp') ? item.inp === true : true) &&
                    (selected.some(opt => opt === 'birth') ? item.birth === true : true) &&
                    (selected.some(opt => opt === 'lab') ? item.lab === true : true) &&
                    (selected.some(opt => opt === 'stom') ? item.stom === true : true) &&
                    (selected.some(opt => opt === 'pharm') ? item.pharm === true : true) &&
                    (selected.some(opt => opt === 'opt') ? item.opt === true : true) &&
                    (selected.some(opt => opt === 'dlvr') ? item.dlvr === true : true) &&
                    (selected.some(opt => opt === 'regn') ? item.regn === true : true)
                );
                this.childTable[id] = this.childTable[id].filter((item) =>
                    (typeof item.displayName === 'string' && item.displayName.toLowerCase().includes(searchLower)) ||
                    (typeof item.address === 'string' && item.address.toLowerCase().includes(searchLower)) ||
                    (typeof item.phone === 'string' && item.phone.toLowerCase().includes(searchLower))
                );
            }
        }
    },
}
</script>
<style scoped>
.clinic-expand {
  padding: 0.5rem 0.75rem 0.75rem;
}

.clinic-filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-bottom: 0.85rem;
}

.clinic-filter-bar__services {
  flex: 0 1 280px;
  width: 280px;
  max-width: 100%;
}

.clinic-filter-bar__search {
  flex: 0 1 220px;
  width: 220px;
  max-width: 100%;
}

.clinic-filter-bar :deep(.el-select__wrapper),
.clinic-filter-bar :deep(.el-input__wrapper) {
  min-height: 36px;
}

@media (max-width: 767.98px) {
  .clinic-filter-bar__services,
  .clinic-filter-bar__search {
    flex: 1 1 100%;
    width: 100%;
  }
}

</style>

<style>
/* Expand panel (type="expand") — no hover glow */
.clinic-groups-table .el-table__expanded-cell,
.clinic-groups-table tr:hover > .el-table__expanded-cell,
.clinic-groups-table tr.hover-row > .el-table__expanded-cell,
.clinic-groups-table .el-table__expanded-cell:hover,
html[data-theme="dark"] .clinic-groups-table .el-table__expanded-cell,
html[data-theme="dark"] .clinic-groups-table tr:hover > .el-table__expanded-cell,
html[data-theme="dark"] .clinic-groups-table tr.hover-row > .el-table__expanded-cell,
html[data-theme="dark"] .clinic-groups-table .el-table__expanded-cell:hover {
  background: #14191f !important;
  background-color: #14191f !important;
  box-shadow: none !important;
}

html[data-theme="light"] .clinic-groups-table .el-table__expanded-cell,
html[data-theme="light"] .clinic-groups-table tr:hover > .el-table__expanded-cell,
html[data-theme="light"] .clinic-groups-table tr.hover-row > .el-table__expanded-cell,
html[data-theme="light"] .clinic-groups-table .el-table__expanded-cell:hover {
  background: #fafbfc !important;
  background-color: #fafbfc !important;
  box-shadow: none !important;
}

/* Child facility rows — keep stable too */
.clinic-groups-table .clinic-child-table.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell,
.clinic-groups-table .clinic-child-table.el-table--enable-row-hover .el-table__body tr.hover-row > td.el-table__cell {
  background: #171c22 !important;
  background-color: #171c22 !important;
  box-shadow: none !important;
  transition: none !important;
}

html[data-theme="light"] .clinic-groups-table .clinic-child-table.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell,
html[data-theme="light"] .clinic-groups-table .clinic-child-table.el-table--enable-row-hover .el-table__body tr.hover-row > td.el-table__cell {
  background: #ffffff !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}
</style>